export const CALLING_APP_DATA_UPDATE = 'CALLING_APP_DATA_UPDATE';

// When data location cannot be determined we update the full structure.

export const addAppDataUpdateListener = cb => {
  window.addEventListener(CALLING_APP_DATA_UPDATE, cb);
};
export const removeAppDataUpdateListener = cb => {
  window.removeEventListener(CALLING_APP_DATA_UPDATE, cb);
};